import { useState, useEffect } from "react";

import { Box, Grid, Autocomplete, Typography, Button, TableContainer, Modal, Table, TableBody, TableHead, TableCell, TableRow, IconButton, FormControl, TextField, useTheme, Divider, InputLabel } from "@mui/material";

import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import 'dayjs/plugin/customParseFormat';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import * as XLSX from "xlsx";
import CallAlertBar from '../../../Layout/Alertbar';
import { useNavigate } from "react-router-dom";
import Header from '../../../Layout/Header'

import { Select, MenuItem } from "@mui/material";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import GlobalConfig from "../../../config/date/GlobalConfig";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CancelIcon from '@mui/icons-material/Cancel';
import QCDataCollection from "../reports/QCDataCollection";
import { CancelOutlined, CheckCircleOutline } from "@mui/icons-material";

const QCPassModel = ({ setViewParentRollList, setViewQCPassModel, GetParentRollList }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [qcdata, setQcdata] = useState([]);
    const navigate = useNavigate();
    const [qcupload, setQcupload] = useState(false);
    const [qcDetailsView, setqcDetailsView] = useState(true);

    const [qcExistingdata, setQcExistingdata] = useState([]);

    const { t, i18n } = useTranslation();
    const [selectedParentRollNumber, setSelectedParentRollNumber] = useState(null);
    const [parentRollNumbers, setparentRollNumbers] = useState([]);
    const [viewParentRollList, setviewParentRollList] = useState(false);
    const [qcStatus, setQcStatus] = useState("");
    const [allQCData, setAllQCData] = useState([]);
    const [disableUpdateBtn, setDisableUpdateBtn] = useState(false);
    const [parentrollItemDetails, setParentrollItemDetails] = useState([]);
    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');


    const [viewQCUpload, setViewQCUpload] = useState(false);

    const btnUploadQCDetails = () => {
        setqcDetailsView(false);
        setViewQCUpload(true);
    }


    const handleChange = (event) => {
        setQcStatus(event.target.value);
    };

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };


    useEffect(() => {

        // Prepare request data
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "";
        const p_mono = 0;

        const orderData = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };

        // API call
        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_LIST_TO_QC_APPROVAL, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then((data) => {
                if (data && data.length > 0) {
                    setparentRollNumbers(data);
                } else {
                    setparentRollNumbers([]);
                    console.warn('No parent roll data available for the given range.');
                }
            })
            .catch((error) => {
                console.error('Error fetching parent roll list:', error.message);
            });

    }, [FromDate, ToDate, setFromDate, setToDate, setparentRollNumbers]);


    const getCertificateDetails = (value) => {
        const orderData = {
            parent_roll_no: value.pr_number,
            p_companyid: localStorage.getItem('companyid')
        }

        callApi(API_ENDPOINTS.PRODUCTION_GetParentRollQCStatus, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then((data) => {
                if (data && data.length > 0) {
                    if (data[0].status === 'booked') {
                        setQcStatus('PASS');
                    }
                    else {
                        setQcStatus(data[0].status);
                    }

                } else {
                    setQcStatus('');
                }
            })
            .catch((error) => {
                alert('Error fetching parent roll status');
            });

        const para = {
            p_jumbo_roll_code: value.pr_number,
        }

        callApi(API_ENDPOINTS.PRODUCTION_GET_QC_CERTIFICATE_DETAILS_WITHOUT_ORDERDETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                // Update state with fetched data
                if (data.length > 0) {
                    const formData = {
                        itemcode: data[0].item_code,
                        gsm: data[0].gsm,
                        size: data[0].size,
                        indentno: data[0].indent_no,
                        line_no: data[0].line_no,
                        caliper: data[0].calipermicron,
                        avggsm: data[0].avggsm,
                        bulkccpergm: data[0].bulkccpergm,
                        stiffnessmd: data[0].stiffnessmd,
                        stiffnesscd: data[0].stiffnesscd,
                        stiffnessgm: data[0].stiffnessgm,
                        ratio: data[0].ratio,
                        cobbtop: data[0].cobbtop,
                        cobbback: data[0].cobbback,
                        plybond: data[0].plybond,
                        igtdrypick: data[0].igtdrypick,
                        roughnesspps: data[0].roughnesspps,
                        moisture: data[0].moisture,
                        brightness: data[0].brightness,
                        gloss: data[0].gloss,
                        backbrightness: data[0].backbrightness

                    };

                    setAllQCData(data);
                    setParentRollMsgOpen(false);

                }
                else {
                    setAllQCData([]);

                    setParentRollSeverityvalue('info');
                    setParentRollMessageValue('No QC certificate details found.!');
                    setParentRollAlertTitleValue('Info');
                    setParentRollMsgOpen(true);
                }


            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });
    }

    const getParentRollWiseItemDetails = (value) => {
        const orderData = {
            parent_roll_no: value.pr_number,
            p_companyid: localStorage.getItem('companyid')
        }

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PARENT_ROLL_WISE_ItemDetails, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then((data) => {
                if (data && data.length > 0) {
                    setParentrollItemDetails(data);
                    setChecked(true);
                } else {
                    setParentrollItemDetails([]);
                    setChecked(false);
                }
            })
            .catch((error) => {
                alert('Error fetching parent roll item details');
            });
    }
    const handleSelectParentRollNumber = (event, value) => {

        const resetState = () => {
            setSelectedParentRollNumber(null);
            setviewParentRollList(false);
            setParentrollItemDetails([]);
            setChecked(false);
            setAllQCData([]);
        };

        if (value) {
            // When a valid value is selected
            setSelectedParentRollNumber(value);
            getCertificateDetails(value);
            getParentRollWiseItemDetails(value);
        } else {
            // When no value or an invalid value is selected
            resetState();
        }
    };






    const [filters, setFilters] = useState({
        cono: '',
        lineno: '',
        newcono: '',
        newlineno: ''
    });
    const filteredData = allQCData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const filteredDataExisting = qcExistingdata.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);

                    // Specify the cellDates option to handle date formatting
                    const workbook = XLSX.read(data, { type: 'array', cellDates: true });

                    // Assuming 'StockData' is the first sheet in the Excel file
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];

                    // Convert sheet data to JSON
                    const jsonData = XLSX.utils.sheet_to_json(sheet);

                    // Define expected columns
                    const expectedColumns = [
                        'CO NO',
                        'LINE ITEM NO',
                        'NEW CO NO',
                        'NEW LINE ITEM NO',
                    ];

                    // Validate if all expected columns are present in the data
                    const areColumnsValid = expectedColumns.every(col =>
                        jsonData.length && col in jsonData[0]
                    );

                    if (!jsonData.length) {
                        alert("No CO Details found!");
                        return;
                    }

                    if (!areColumnsValid) {
                        alert("Invalid file! Please select a valid file with the expected columns.");
                        return;
                    }

                    // Add incremental IDs to each row and validate each field
                    const dataWithIds = jsonData.map((row, index) => {
                        const hasEmptyField = expectedColumns.some(col =>
                            row[col] === undefined || row[col] === null || row[col] === ''
                        );

                        return {
                            id: index + 1,
                            ...row,
                            isValid: !hasEmptyField, // true if no empty fields, false otherwise
                        };
                    });

                    // Set the data to state
                    setQcdata(dataWithIds);


                } catch (error) {
                    alert("An error occurred while processing the file. Please select a valid file.");
                    console.error("File processing error:", error);
                }
            };

            reader.readAsArrayBuffer(file);
        } else {
            alert("No file selected. Please select a valid file.");
        }
    };




    const downloadExcelFile = () => {
        const excelFilePath = '/excel-templates/UploadPoDataFile.xlsx';
        const link = document.createElement('a');
        link.href = excelFilePath;
        link.download = 'UploadPoDataFile.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const callApiForSaveCustomerOrderMappingData = async (requestBody) => {
        try {
            const response = await fetch(API_ENDPOINTS.PRODUCTION_PARENTROLL_UPDATE_QC_APPROVAL_STATUS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                throw new Error('Unable to update QC status');
            }
            const data = await response.json();
            if (data.length > 0) {
                setParentRollSeverityvalue('info');
                setParentRollMessageValue('Parent Roll QC Status updated successfully..!');
                setParentRollAlertTitleValue('Info');
                setParentRollMsgOpen(true);
            }
            else {
                setParentRollSeverityvalue('error');
                setParentRollMessageValue('Unable to update QC status..!');
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            }



        } catch (error) {
            msg('error', 'Error', 'Unable to update QC status');
            throw error; // rethrow the error so that the calling function can handle it
        }
    };



    // Function to prepare data for the API
    const prepareDataForAPI = () => {
        return qcdata
            .filter(row => selectedRows.includes(row.id)) // Only include selected rows
            .map(row => ({
                cono: row["CO NO"],
                lineno: row["LINE ITEM NO"],
                newcono: row["NEW CO NO"],
                newlineno: row["NEW LINE ITEM NO"],
            }));
    };



    async function UpdateQCApprovalStatus() {
        if (!selectedParentRollNumber) {
            // If no valid rows, handle the case (e.g., show a message to the user)

            setParentRollSeverityvalue('warning');
            setParentRollMessageValue('Please select Parent Roll Number for update status.!');
            setParentRollAlertTitleValue('Warning');
            setParentRollMsgOpen(true);
            return;
        }

        else if (!qcStatus) {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue('Please select QC Status for update.!');
            setParentRollAlertTitleValue('Warning');
            setParentRollMsgOpen(true);
            return;
        }

        const requestBody = {
            qc_approval_status: qcStatus,
            p_companyid: localStorage.getItem('companyid'),
            p_pr_number: selectedParentRollNumber.pr_number,
        };

        await callApiForSaveCustomerOrderMappingData(requestBody);
    }





    // State to track selected rows
    const [selectedRows, setSelectedRows] = useState([]);

    // Handle Select All Click
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Select all valid rows
            const allValidRowIds = filteredData.filter(row => row.isValid).map(row => row.id);
            setSelectedRows(allValidRowIds);
        } else {
            // Deselect all rows
            setSelectedRows([]);
        }
    };

    // Handle Individual Row Selection
    const handleRowCheckboxClick = (event, id) => {
        const selectedIndex = selectedRows.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }

        setSelectedRows(newSelected);
    };

    // Check if a row is selected
    const isSelected = (id) => selectedRows.indexOf(id) !== -1;

    const [deckleMatchingMsgOpen, setDeckleMatchingMsgOpen] = useState(false);
    const [deckleMatchingSeverityvalue, setDeckleMatchingSeverityvalue] = useState('info');
    const [deckleMatchingMessageValue, setDeckleMatchingMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [deckleMatchingAlertTitleValue, setDeckleMatchingAlertTitleValue] = useState('');

    const msg = (severityvalue, title, messageValue) => {
        setDeckleMatchingSeverityvalue(severityvalue);
        setDeckleMatchingMessageValue(messageValue);
        setDeckleMatchingAlertTitleValue(title);
        setDeckleMatchingMsgOpen(true);
    };


    const getAllCustomerOrderMappingDetails = () => {
        let parameters = {
            p_companyid: localStorage.getItem('companyid'),

        };

        callApi(API_ENDPOINTS.CUSTOMERORDER_MAPPING_GetALLCustomerOrderMappingDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {

                const dataWithSerialNumbers = data.map((item, index) => ({
                    ...item,
                    id: index + 1, // Generate serial number starting from 1
                }));

                // Set the modified data
                setQcExistingdata(dataWithSerialNumbers);

            })
            .catch(error => {
                // // Update state with error message        
                // setReelWeightementSeverityvalue('error');
                // setReelWeightementMessageValue(error.message);
                // setReelWeightementAlertTitleValue('Error');
                // setReelWeightementMsgOpen(true);
            });

    };

    const handleViewQCUpload = () => {
        setViewQCUpload(true);
        setqcDetailsView(false);



    }

    const handleViewQCDetailsView = () => {
        setViewQCUpload(false);
        setqcDetailsView(true);

    }


    const handleClosePage = () => {
        //navigate("/");
        setViewParentRollList(true);
        setViewQCPassModel(false);
        GetParentRollList();
    }

    const handleClose = () => {
        setOpen(false);
    };



    useEffect(() => {
        if (qcExistingdata) {
            getAllCustomerOrderMappingDetails();
        }

    }, [qcExistingdata]);


    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleBackWinderMachineEntry = () => {


    }
    const [checked, setChecked] = useState(false);

    return (
        <>
            {qcDetailsView && (
                <Box >

                    <Box style={{}} flexDirection={'row'} >
                        <Header title={'QC Approval for Parent Roll'} subtitle="" callback={handleClosePage} />

                    </Box>
                    <Divider />

                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Box >
                        <Box display="flex" flexDirection={'column'}>
                            <Box m='0px' display="flex" justifyContent={'flex-start'}>
                                <Grid container  >
                                    <Grid mt={1} mr={4} item xs={12} sm={12} md={5} lg={5} xl={5}   >

                                        <Grid container padding="5px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" > {t('prod_winder_machine.filter_by')} </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            style={{ marginLeft: '10px' }}
                                                            id="FromDate"
                                                            value={dayjs(FromDate)}
                                                            onChange={(date) => handleDateChange2(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            autoFocus
                                                            format="DD-MMM-YYYY"
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>



                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                                <FormControl fullWidth size="small" >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                        <DatePicker
                                                            id="ToDate"
                                                            value={dayjs(ToDate)}
                                                            format="DD-MMM-YYYY"
                                                            onChange={(date) => handleDateChange1(date)}
                                                            slotProps={{ textField: { size: 'small', } }}
                                                            renderInput={(props) => <TextField {...props} />}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>

                                        </Grid>

                                        <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    {t('prod_winder_machine.parent_roll_number')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                                                <Autocomplete
                                                    autoFocus
                                                    variant="standard"
                                                    // style={{ width: '300px' }}
                                                    value={selectedParentRollNumber}
                                                    onChange={handleSelectParentRollNumber}
                                                    fontSize="10px"
                                                    size="small"
                                                    disabled={viewParentRollList}
                                                    options={parentRollNumbers}
                                                    getOptionLabel={(option) => `${option.pr_number}`} // Assuming lot numbers are strings
                                                    renderInput={(params) => <TextField {...params} variant="outlined" />}//label="MO - ParentRoll"
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container padding="5px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                    QC Status
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>

                                                <FormControl fullWidth margin="dense" size="small">
                                                    {/* <InputLabel id="qc-status-label">QC Status</InputLabel> */}
                                                    <Select
                                                        labelId="qc-status-label"
                                                        id="qc-status"
                                                        value={qcStatus}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        <MenuItem value="">
                                                            <em>Select QC Status</em>
                                                        </MenuItem>
                                                        <MenuItem value="PASS">
                                                            <CheckCircleOutline  style={{ color: 'green', marginRight: 8 ,fontSize: 'small'}} />
                                                            PASS
                                                        </MenuItem>
                                                        <MenuItem value="HOLD">
                                                            <HourglassEmptyIcon style={{ color: 'orange', marginRight: 8 ,fontSize: 'small'}} />
                                                            HOLD
                                                        </MenuItem>
                                                        <MenuItem value="REJECT">
                                                            <CancelOutlined style={{ color: 'red', marginRight: 8 ,fontSize: 'small'}} />
                                                            REJECT
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>


                                        </Grid>

                                        <Grid container padding="5px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex" justifyContent='end' >
                                                <Button size="small" variant="contained" disabled={disableUpdateBtn} color="secondary" onClick={UpdateQCApprovalStatus} sx={{ textTransform: 'none' }}>Update</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={1} mt={1} item xs={12} sm={12} md={5} lg={5} xl={5}   >

                                        {checked && (
                                            <Divider orientation="vertical" flexItem sx={{ width: "2px" }} />
                                        )}
                                        {checked && (
                                            <Grid ml={0.5} item xs={12} sm={12} md={8} lg={8} xl={8}>
                                                <Box sx={{ padding: 0 }}>
                                                    <Typography sx={{
                                                        display: 'inline-flex',

                                                    }} variant="h5" gutterBottom mb={1}>
                                                        Qualtiy & GSM in Parent Roll :
                                                    </Typography>


                                                    <Box
                                                        gridColumn="span 9"
                                                        gridRow="span 1"
                                                        alignItems="center"
                                                        justifyContent="center"

                                                        sx={{
                                                            "& .MuiTable-root": {
                                                                border: "none",
                                                                size: "small",
                                                            },
                                                            "& .MuiTableCell-root": {
                                                                borderBottom: "none",
                                                                border: "1px solid",
                                                                borderColor: `${colors.primary[300]} !important`,
                                                                padding: "5px",  // Further reduced padding
                                                            },
                                                            "& .MuiTableHead-root": {
                                                                borderBottom: "none",
                                                            },
                                                            "& .MuiTableBody-root": {
                                                                overflowY: "auto",
                                                            },
                                                            "& .MuiCheckbox-root": {
                                                                color: `${colors.blueAccent[200]} !important`,
                                                                size: "small",
                                                            },
                                                            "& .MuiTableFooter-root": {
                                                                borderTop: "none",
                                                                backgroundColor: colors.blueAccent[700],
                                                                height: "10px",
                                                            },
                                                            "& .MuiButton-text": {
                                                                color: `${colors.grey[100]} !important`,
                                                            },
                                                            // scroll bar
                                                            maxHeight: {
                                                                xs: '72vh', // Extra small devices (phones)
                                                                sm: '72vh', // Small devices (tablets)
                                                                md: '74vh', // Medium devices (small laptops)
                                                                lg: '63vh', // Large devices (desktops)
                                                                xl: '80vh', // Extra large devices (large desktops)
                                                            },

                                                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                            '&::-webkit-scrollbar': {
                                                                width: '8px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                background: colors.primary[400],
                                                                borderRadius: '10px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                background: colors.blueAccent[600],
                                                                borderRadius: '10px',
                                                                '&:hover': {
                                                                    background: colors.blueAccent[800],
                                                                },
                                                            },
                                                            '&::-webkit-scrollbar-corner': {
                                                                background: colors.primary[700],
                                                            }
                                                        }}
                                                    >

                                                        <TableContainer size='small'>
                                                            <Table size="small" stickyHeader>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Quality</TableCell>
                                                                        <TableCell>GSM</TableCell>

                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {parentrollItemDetails.map((row) => (
                                                                        <TableRow >
                                                                            <TableCell>{row.item_code}</TableCell>
                                                                            <TableCell>{row.gsm}</TableCell>

                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer></Box>
                                                </Box>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box padding="10px 15px 15px 15px" >
                                <Divider />
                            </Box>

                            <Box pl={2} display={'flex'} justifyContent={'space-between'}>
                                <Typography variant="h5" >QC Certificate details</Typography>

                                <Button size="small" variant="contained" color="secondary" startIcon={<UploadFileIcon />} onClick={handleViewQCUpload}
                                    sx={{ textTransform: 'none', marginRight: '25px' }}>Upload QC</Button>

                            </Box>

                            <Box
                                gridColumn="span 9"
                                gridRow="span 1"
                                alignItems="center"
                                justifyContent="center"
                                padding={2}
                                sx={{
                                    "& .MuiTable-root": {
                                        border: "none",
                                        size: "small",
                                    },
                                    "& .MuiTableCell-root": {
                                        borderBottom: "none",
                                        border: "1px solid",
                                        borderColor: `${colors.primary[400]} !important`,
                                        padding: "5px",  // Further reduced padding
                                    },
                                    "& .MuiTableHead-root": {
                                        borderBottom: "none",
                                    },
                                    "& .MuiTableBody-root": {
                                        overflowY: "auto",
                                    },
                                    "& .MuiCheckbox-root": {
                                        color: `${colors.blueAccent[200]} !important`,
                                        size: "small",
                                    },
                                    "& .MuiTableFooter-root": {
                                        borderTop: "none",
                                        backgroundColor: colors.blueAccent[700],
                                        height: "10px",
                                    },
                                    "& .MuiButton-text": {
                                        color: `${colors.grey[100]} !important`,
                                    },
                                    // scroll bar
                                    maxHeight: {
                                        xs: '72vh', // Extra small devices (phones)
                                        sm: '72vh', // Small devices (tablets)
                                        md: '74vh', // Medium devices (small laptops)
                                        lg: '63vh', // Large devices (desktops)
                                        xl: '80vh', // Extra large devices (large desktops)
                                    },

                                    overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: colors.primary[400],
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: colors.blueAccent[600],
                                        borderRadius: '10px',
                                        '&:hover': {
                                            background: colors.blueAccent[800],
                                        },
                                    },
                                    '&::-webkit-scrollbar-corner': {
                                        background: colors.primary[700],
                                    }
                                }}
                            >
                                <TableContainer >
                                    <Table stickyHeader size="small" sx={{ tableLayout: 'auto' }}>

                                        <TableHead sx={{ height: 25 }}>
                                            <TableRow>
                                                {/* <TableCell>PRODUCTION DATE</TableCell>
                                                            <TableCell>JUMBO NO</TableCell> */}
                                                <TableCell sx={{ width: '100px' }}>QUALITY</TableCell>
                                                <TableCell sx={{ width: '80px' }}>ORDER GSM</TableCell>
                                                <TableCell sx={{ width: '60px' }}>AVG GSM</TableCell>
                                                <TableCell sx={{ width: '100px' }}>CALPER(micron)</TableCell>
                                                <TableCell sx={{ width: '130px' }}>BULK(cc/gm)</TableCell>
                                                <TableCell sx={{ width: '130px' }}>STIFFNESS MD(mN)</TableCell>
                                                <TableCell sx={{ width: '130px' }}>STIFFNESS CD(mN)</TableCell>
                                                <TableCell sx={{ width: '130px' }}>STIFFNESS GM(mN)</TableCell>
                                                <TableCell sx={{ width: '100px' }}>RATIO</TableCell>
                                                <TableCell sx={{ width: '80px' }}>COBB TOP</TableCell>
                                                <TableCell sx={{ width: '100px' }}>COBB BACK</TableCell>
                                                <TableCell sx={{ width: '100px' }}>PLYBOND(J/m2)</TableCell>
                                                <TableCell sx={{ width: '130px' }}>IGT DRY PICK(m/sec)</TableCell>
                                                <TableCell sx={{ width: '130px' }}>ROUGHNESS PPS(um)</TableCell>
                                                <TableCell sx={{ width: '100px' }} >GLOSS(%)</TableCell>
                                                <TableCell sx={{ width: '100px' }}>MOISTURE(%)</TableCell>
                                                <TableCell sx={{ width: '100px' }}>BRIGHTNESS(%)</TableCell>
                                                <TableCell sx={{ width: '100px' }}>BACK BRIGHTNESS(%)</TableCell>
                                                <TableCell>
                                                    <IconButton >
                                                        {/* onClick={handleOpen}
                                                                            <Searchicon style={{ fontSize: "16px" }} /> */}
                                                    </IconButton>
                                                    <Modal
                                                        // open={open}
                                                        // onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                            <TextField
                                                                label="Parent Roll Number"
                                                                name="name"
                                                                // value={filters.pr_number}
                                                                // onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="MA Number"
                                                                name="companyName"
                                                                // value={filters.release_no}
                                                                //onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="Status"
                                                                name="status"
                                                                // value={filters.status}
                                                                //onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <Button variant="contained" style={{ marginTop: 10 }}>
                                                                {/* onClick={handleClose} */}
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredData.map((row) => (
                                                <TableRow key={row.id}>

                                                    {/* <TableCell>{row.date}</TableCell>
                                                                <TableCell>{row.jumbono}</TableCell> */}
                                                    <TableCell >{row.item_code}</TableCell>
                                                    <TableCell >{row.gsm}</TableCell>
                                                    <TableCell>{row.avggsm}</TableCell>
                                                    <TableCell>{row.calipermicron}</TableCell>
                                                    <TableCell>{row.bulkccpergm}</TableCell>
                                                    <TableCell>{row.stiffnessmd}</TableCell>
                                                    <TableCell>{row.stiffnesscd}</TableCell>
                                                    <TableCell>{row.stiffnessgm}</TableCell>
                                                    <TableCell>{row.ratio}</TableCell>
                                                    <TableCell>{row.cobbtop}</TableCell>
                                                    <TableCell>{row.cobbback}</TableCell>
                                                    <TableCell>{row.plybond}</TableCell>
                                                    <TableCell>{row.igtdrypick}</TableCell>
                                                    <TableCell>{row.roughnesspps}</TableCell>
                                                    <TableCell>{row.gloss}</TableCell>
                                                    <TableCell>{row.moisture}</TableCell>
                                                    <TableCell>{row.brightness}</TableCell>
                                                    <TableCell>{row.backbrightness}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Box>




                    </Box>

                </Box>

            )}

            {viewQCUpload && (
                
                <QCDataCollection handleBackWinderMachineEntry={handleViewQCDetailsView} />
            )}




        </>
    )
};
export default QCPassModel;